import enCATranslations from './enCA';
import enUSTranslations from './enUS';
import csCZTranslations from './csCZ';
import deDETranslations from './deDE';
import esESTranslations from './esES';
import esMXTranslations from './esMX';
import frCATranslations from './frCA';
import frFRTranslations from './frFR';
import itITTranslations from './itIT';
import jaJATranslations from './jaJA';
import krKOTranslations from './krKO';
import plPLTranslations from './plPL';
import ptPTTranslations from './ptPT';
import ptBRTranslations from './ptBR';
import ruRUTranslations from './ruRU';
import thTHTranslations from './thTH';
import trTRTranslations from './trTR';
import viVNTranslations from './viVN';
import zhCNTranslations from './zhCN';
import zhTWTranslations from './zhTW';

const allTranslations = Object.freeze({
  ...enCATranslations,
  ...enUSTranslations,
  ...csCZTranslations,
  ...deDETranslations,
  ...esESTranslations,
  ...esMXTranslations,
  ...frFRTranslations,
  ...frCATranslations,
  ...itITTranslations,
  ...jaJATranslations,
  ...krKOTranslations,
  ...plPLTranslations,
  ...ptPTTranslations,
  ...ptBRTranslations,
  ...ruRUTranslations,
  ...thTHTranslations,
  ...trTRTranslations,
  ...viVNTranslations,
  ...zhCNTranslations,
  ...zhTWTranslations
});

export default allTranslations;
